<template>
  <div class="text-center">
    <h4>Please contact ColonyLive sales team to activate this feature.</h4>
    <div class="mail-container">
      <a class="mail-to-link" :href="mailToSales">
        <i class="fa fa-envelope"></i>
        Contact Sales
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactSales',
  data: () => ({
    mailToSales: 'mailto:robby@colonyhq.com?subject=Colony%20Live%20Afstereo%20Plugin%20Request',
  }),
};
</script>

<style lang="scss">
.mail-to-link{
  padding: 6px;
  color: #fff;
  background-color: #683090;
  border-color: #683090;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// ContactSales.vue?09040d5c